import type { Translate } from '@athena/i18n'

/**
 * A plan's name, in the reader's language.
 *
 * The dictionary keys are the enum values verbatim — `subscription.planName.FREE`
 * — which is the same arrangement `questionType.*` and `userError.*` use, and
 * for the same reason: the server sends a code and the client owns the wording,
 * so a renamed plan is a dictionary edit rather than a deploy of both halves.
 *
 * "Premium" and "Premium Plus" are the same word in both languages today, and
 * they are still in the dictionary rather than rendered from the code. A plan
 * name is user-facing text, and the one that is not the same — Free/Gratis —
 * would otherwise be a special case somebody has to remember.
 */
export function planName(t: Translate, code: string): string {
  switch (code) {
    case 'FREE':
      return t('subscription.planName.FREE')
    case 'PREMIUM':
      return t('subscription.planName.PREMIUM')
    case 'PREMIUM_PLUS':
      return t('subscription.planName.PREMIUM_PLUS')
    default:
      // A plan this build has no name for, which is a newer API against an
      // older bundle. The code is a poor label and a better one than blank.
      return code
  }
}
